var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FileInput',{staticClass:"vue-fine-uploader-gallery-file-input-container",attrs:{"uploader":_vm.uploader,"multiple":_vm.multiple}},[_c('span',{staticClass:"vue-fine-uploader-gallery-file-input-content"},[_vm._t("default",[_c('UploadIcon',{staticClass:"vue-fine-uploader-gallery-file-input-upload-icon"}),_vm._v("\n      Select Files\n    ")])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6180ebba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-fineuploader/gallery/FileInputComponent.vue
// module id = g9zK
// module chunks = 0